import MaterialTable from '@material-table/core';
import { Add, Delete, Edit, Save } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { tableIcons, tableLocalization } from '../../../@jumbo/constants/TableConstants';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import axios_instance from '../../../services/auth/jwt/config';
import sweetAlert from '../../../f5/utils/sweetAlert';
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';

interface ObraEmpresaIndexProps {
}

type Empresa = {
  id: number,
  nome: string,
}

export default function ObraEmpresaIndex({ ...props }: ObraEmpresaIndexProps) {
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [editing, setEditing] = useState<Empresa>({
    id: 0,
    nome: '',
  });

  const onLoad = () => {
    setLoading(true);
    axios_instance.get<{ success: boolean, data: Empresa[] }>('obra/ordem_servico/empresa/index').then((response) => {
      const r = response.data;
      if (r.success) {
        setEmpresas(r.data);
      }
    }).catch(() => {
      sweetAlert('error', 'Erro', 'Erro ao carregar as empresas');
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    onLoad();
  }, []);

  const onDelete = (rowData: Empresa) => {
    setSending(true);
    axios_instance.delete<{ success: boolean, message: string }>(`obra/ordem_servico/empresa/delete/${rowData.id}`).then((response) => {
      const r = response.data;
      if (r.success) {
        onLoad();
        sweetAlert('success', 'Sucesso', r.message);
      } else {
        sweetAlert('error', 'Erro', r.message);
      }
    }).catch(() => {
      sweetAlert('error', 'Erro', 'Erro ao excluir a empresa');
    }).finally(() => {
      setSending(false);
    });
  };

  const onSave = () => {
    if (!editing.nome.trim()) {
      sweetAlert('warning', 'Atenção', 'Informe o nome da empresa');
      return;
    }

    setSending(true);
    setOpenModal(false);
    axios_instance.post<{ success: boolean, message: string }>(`obra/ordem_servico/empresa/save${editing.id === 0 ? '' : `/${editing.id}`}`, {
      nome: editing.nome.trim(),
    }).then((response) => {
      const r = response.data;
      if (r.success) {
        onLoad();
        sweetAlert('success', 'Sucesso', r.message);
      } else {
        sweetAlert('error', 'Erro', r.message);
      }
    }).catch(() => {
      sweetAlert('error', 'Erro', 'Erro ao salvar a empresa');
    }).finally(() => {
      setSending(false);
    });
  };

  const isSaveDisabled = !editing.nome.trim();

  // @ts-ignore
  return <PageContainer>
    <MaterialTable
      title="Empresas"
      columns={[
        { title: 'Nome', field: 'nome' },
      ]}
      data={empresas}
      actions={[
        {
          isFreeAction: true,
          icon: () => <Add />,
          tooltip: 'Adicionar',
          onClick: () => {
            setOpenModal(true);
            setEditing({
              id: 0,
              nome: '',
            });
          },
        },
        {
          icon: () => <Edit />,
          tooltip: 'Editar',
          onClick: (event, rowData) => {
            if (!rowData || Array.isArray(rowData)) {
              return;
            }

            setOpenModal(true);
            setEditing({
              id: rowData.id,
              nome: rowData.nome,
            });
          },
        },
        {
          icon: () => <Delete />,
          tooltip: 'Excluir',
          onClick: (event, rowData) => {
            if (!rowData || Array.isArray(rowData)) {
              return;
            }

            sweetAlert('warning', 'Atenção', 'Deseja realmente excluir esta empresa?', () => {
              onDelete(rowData);
            });
          },
        },
      ]}
      localization={tableLocalization}
      icons={tableIcons}
      isLoading={loading}
    />
    <Backdrop open={sending} style={{ zIndex: 9999 }}>
      <Box display="flex" justifyContent="center" alignItems="center" height="100%" color="white">
        <CircularProgress />
        <Typography variant="h6" style={{ marginLeft: 10 }}>Enviando...</Typography>
      </Box>
    </Backdrop>
    <Dialog open={openModal} onClose={() => setOpenModal(false)}>
      <DialogTitle>
        {editing.id === 0 ? 'Adicionar' : 'Editar'} Empresa
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Nome"
          fullWidth
          variant="outlined"
          margin="normal"
          value={editing.nome}
          onChange={(e) => setEditing({ ...editing, nome: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" width="100%">
          <Button variant="contained" color="secondary" onClick={() => setOpenModal(false)}>Cancelar</Button>
          <Button
            variant="contained"
            startIcon={<Save />}
            style={{ backgroundColor: '#4caf50', color: 'white' }}
            onClick={onSave}
            disabled={isSaveDisabled}
          >
            Salvar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  </PageContainer>;
}
